import React from "react";

import {AuthenticatedTemplate, UnauthenticatedTemplate} from "@azure/msal-react";

import Header from "template/Header";
import Sidebar from "template/Sidebar";
import {Routes, Route, Navigate} from "react-router";
import Login from 'pages/Login';
import {ToastContainer} from "react-toastify";
import RoutesApp from './Routes';

import { AuthProvider } from "store/providers/app"
import { TagsProvider} from "./store/providers/tags";

const ProfileContent = () => {
    return (
        <AuthProvider>
            <TagsProvider>
                <div className="wrapper">
                    <Header />
                    <Sidebar/>
                    <RoutesApp/>
                </div>
            </TagsProvider>
        </AuthProvider>
    );
};

const MainContent = () => {
    return (
        <div className="App">
            <ToastContainer autoClose={2000}/>
            <AuthenticatedTemplate>
                <ProfileContent />
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                <Routes>
                    <Route path="/" element={<Login />}/>
                    <Route path="*" element={<Navigate to={'/'} />}/>
                </Routes>
            </UnauthenticatedTemplate>
        </div>
    );
};

export default function App() {
    return <MainContent />
}
